import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import useEquipmentEnabled from 'hooks/settings/useEquipmentEnabled/useEquipmentEnabled';
import { IChildrenProps } from 'types/ChildrenProps';

function EquipmentConditionalContainer({ children }: IChildrenProps) {
  return <ConditionalContainer condition={useEquipmentEnabled()}>{children}</ConditionalContainer>;
}

export default EquipmentConditionalContainer;
